module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/elon-university-9c2883b5c1476c9fe4f6e8078bb864aa.svg";